var map = {
	"./Mask.png": 2930,
	"./bottom-nav.png": 2931,
	"./channels/facebook_login.png": 2240,
	"./chatwoot_bot.png": 2775,
	"./email.png": 2932,
	"./facebook.png": 2933,
	"./instagram.png": 2934,
	"./no_page_image.png": 2935,
	"./whatsapp.png": 2936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2929;